import React, { useMemo } from "react";
import { useLocation } from "react-router-dom";

import { NavDivider } from "../../assets/icons";
import { CardContainer } from "./CardContainer";
import { SectionContainer } from "./SectionContainer";
import { Header } from "./Header";
import { useAppSelector } from "../../hooks/hooks";
import { NavDividerProps } from "./types";

const ViewAll: React.FC<{
  onSignInClick?: () => void;
  onSignUpClick?: () => void;
}> = ({ onSignInClick, onSignUpClick }) => {
  const location = useLocation();
  const { data: appData } = useAppSelector((state) => state.appData);
  const selectedCountry = useAppSelector(
    (state) => state.locale.selectedCountry,
  );

  // Extract the last path segment as the category key
  const path = location.pathname;
  const pathSegment = path.split("/").filter(Boolean).pop() || "";

  // Derive display title
  const formattedTitle =
    pathSegment?.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase()) ||
    "Plans";

  // Determine the data source (flatten providers if needed)
  const filteredProviders = useMemo(() => {
    const categoryData = (appData as any)[pathSegment];
    const providers = categoryData?.providers;

    if (!providers || !selectedCountry?.id || !appData) {
      return providers || [];
    }

    // Filter providers based on country
    return providers.filter((provider: any) => {
      // Get categories for this provider
      const providerCategoryIds =
        appData.data?.categories
          ?.filter((cat: any) => cat.provider_id === provider.id)
          ?.map((cat: any) => cat.id) || [];

      // Check if any plan matches both category and country
      const hasMatchingCountry = appData.data?.plans?.some((plan: any) => {
        const isInCategory = providerCategoryIds.includes(plan.category_id);

        const hasCountry =
          plan.countries && Array.isArray(plan.countries)
            ? plan.countries.includes(selectedCountry.id)
            : false;

        return isInCategory && hasCountry;
      });

      return hasMatchingCountry;
    });
  }, [appData, pathSegment, selectedCountry?.id]);
  return (
    <div>
      <div className="px-14 pt-14 pb-2">
        <div className="row-1 gap-[2px] place-items-center">
          {/* Dynamic navigation links */}
          <Navigation title="Direct Top-up Product Details" />
          <NavDivider />
          <Navigation title={formattedTitle} />
        </div>
      </div>

      <div>
        {filteredProviders && filteredProviders.length > 0 && (
          <SectionContainer>
            <Header
              icon="/png/PrepaidServices.png"
              title="Prepaid Services"
              viewAllUrl="/data"
            />
            <CardContainer cardData={filteredProviders} url="data" />
          </SectionContainer>
        )}
      </div>
    </div>
  );
};

export default ViewAll;

const Navigation: React.FC<NavDividerProps> = ({ href, title }) => (
  <a
    href={href || "#"} // Default to "#" if href is not provided
    className="satoshi-xs-bold-toggleBG-dark dark:text-white"
  >
    {title}
  </a>
);
